import { render, staticRenderFns } from "./veStuAssocActivityRecord.vue?vue&type=template&id=29297835&scoped=true"
import script from "./veStuAssocActivityRecord.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29297835",
  null
  
)

export default component.exports